<template>
  <div class="wrapper-feedback wh100p df-l-fs">
    <section class="section-navs df">
      <div class="back-btn _themecolor f-m df-c-ct" @click="$router.go(-1)">
        <img class="arrow" :src="iconArrowLeft">
        <div>{{$t('feedback.feedbackList')}}</div>
      </div>
    </section>
    <section class="section-con f1 scrolly">
      <div class="header df-c-sb">
        <div class="f-s">
          <span>{{$t('feedback.status')}}：</span>
          <span :class="{'_redcolor':feedbackData.status!==3}">{{$t('feedback.status'+feedbackData.status)}}</span>
        </div>
        <div class="f-s">{{$t('feedback.feedbackTime')}}：{{feedbackData.createDate}}</div>
      </div>
      <div class="_borderbottom">
        <div class="title f-s df">
          <span class="label1">{{$t('feedback.title')}}：</span>
          <span class="f1 f-xxl f-bold sls">{{feedbackData.title}}</span>
        </div>
        <div class="content f-s df">
          <span class="label1">{{$t('feedback.content')}}：</span>
          <span class="f1">{{feedbackData.content}}</span>
        </div>
      </div>
      <div>
        <div class="content df-sb" v-for="(x,i) in replyData" :key="i">
          <div class="label2">{{x.dealPerson}}：</div>
          <div class="value f1">{{x.content}}</div>
          <div class="time">{{x.createDate}}</div>
        </div>
      </div>
      <div v-if="feedbackData.status!==3">
        <textarea class="textarea mytextarea" :placeholder="$t('feedback.inputReply')" v-model="replyText" @focus="onFocus_forScan" @blur="onBlur_forScan" />
        <div class="btns df-c-fe">
          <div class="whitebtn" @click="markFinished">{{$t('feedback.status3')}}</div>
          <div class="themebtn btn" @click="sendReply">{{$t('feedback.reply')}}</div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'feedbackDetail',
  data() {
    return {
      feedbackId: '',
      feedbackData: {},
      replyText: '',
      replyData: [],
    }
  },
  methods: {
    async markFinished() {
      const _D = await this.setData('feedback', {
        id: this.feedbackId,
        status: 3,
      })
      if (_D === 'ok') {
        this.feedbackData.status = 3
      }
    },
    async sendReply() {
      if (this.replyText) {
        let rD = {
          shopId: this.currentShopId,
          parentId: this.feedbackId,
          content: this.replyText,
          dealPerson: this.user_x.nickName,
        }
        const _R = await this.newData('feedback', rD)
        if (_R) {
          this.replyData.push(_R)
          this.replyText = ''
          if (this.feedbackData.status !== 2) {
            this.setData('feedback', {
              id: this.feedbackId,
              status: 2,
            })
          }
        }
      } else { this.$message.warning(this.$t('feedback.inputReply')) }
    },
    async getFeedbackReply() {
      const _R = await this.getData('feedback', {
        shopId: this.currentShopId,
        parentId: this.feedbackId,
      })
      // console.log(`%c反馈回復:`, 'color: #00f;', _R)
      this.replyData = _R.map(x => {
        x.platformFeedback && (x.dealPerson = this.$t('feedback.platform'))
        return x
      })
    },
    async getFeedback() {
      const _R = await this.getData('feedback', {
        shopId: this.currentShopId,
        id: this.feedbackId,
      })
      // console.log(`%c反馈:`, 'color: #00f;', _R[0])
      if (_R.length) {
        this.feedbackData = _R[0]
      }
    },
    // 获取数据
    async init() {
      this.getFeedback()
      this.getFeedbackReply()
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.feedbackId = to.query.id
      vm.init()
    })
  },
}
</script>

<style lang='scss' scoped>
// .wrapper-feedback{padding: 20px 0 0 20px;box-sizing: border-box;}
.section-title{height: 80px;line-height: 80px;background: #fff;padding-left: 20px;margin-bottom: 20px;font-weight: bold;}
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;margin-bottom: 20px;
  .back-btn{
    padding: 0 10px;width: auto;height: 80px;white-space: nowrap;font-weight: bold;
    .arrow{width: 24px;height: 24px;margin-right: 12px;}
  }
}
.section-con{
  background: #fff;margin-left: 20px;padding: 0 20px;
  .header{height: 64px;line-height: 64px;}
  .title{height: 80px;line-height: 80px;}
  span{display: inline-block;}
  // .label1{width: 60px;text-align: right;}
  // .label2{width: 80px;text-align: right;}
  .content{height: auto;line-height: 24px;padding: 10px 0 30px;}
  .time{width: 200px;}
  .value{margin-right: 80px;}
  .textarea{width: calc(100% - 24px);height: 130px;margin: 12px;}
  .btns{padding: 30px 0;}
  .btn{margin-left: 30px;}
}
</style>